export default __webpack_public_path__ + "static/media/masterCard.2e1191ba.svg";